import React, { useContext, useMemo } from 'react';
import { useSplitTreatments } from '@splitsoftware/splitio-react';

import { SplitReadyContext } from './SplitReadyContext';
import { SplitScope } from './SplitScope';

type Treatments = Record<string, { treatment: string; config?: string | null }>;

type Props = {
    names: string[];
    attributes?: Record<string, any>;
    children: (treatments: Treatments) => React.ReactNode;
};

function controlTreatments(names: string[]): Treatments {
    return Object.fromEntries(names.map((n) => [n, { treatment: 'control', config: null }]));
}

function LiveSplitTreatments({ names, attributes, children }: Props) {
    const { treatments } = useSplitTreatments({ names, attributes });
    return <>{children(treatments as Treatments)}</>;
}

/** Renders control treatments until Split is idle-initialized, then live flags. */
export function SafeSplitTreatments({ names, attributes, children }: Props) {
    const ready = useContext(SplitReadyContext);
    const controls = useMemo(() => controlTreatments(names), [names]);

    if (!ready) {
        return <>{children(controls)}</>;
    }
    return (
        <SplitScope>
            <LiveSplitTreatments names={names} attributes={attributes}>
                {children}
            </LiveSplitTreatments>
        </SplitScope>
    );
}
